// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 600px) {
    #device-setup-procedure{
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
        overflow: hidden;

        position: absolute;
        top:0;
        left:0;
        width:100%;
        height: 100vh;
        background: black;
    }
    #device-setup-procedure h1, #device-setup-procedure button{
        font-family: 'Ubuntu', sans-serif;
        outline:none!important;
    }
    #device-setup-procedure button:focus{
        outline:none!important;
    }
    #device-setup-procedure .op1{
        opacity: 1!important;
    }
    #device-setup-procedure .op0{
        opacity: 0!important;
    }
    #device-setup-procedure #network-list{
        margin-top: 2vw!important;
        opacity: 1;
        transition: opacity 1s;
    }
    #device-setup-procedure #network-list-to-select{
        margin-top: 3em;
        padding: 5em;
    }
    #device-setup-procedure .network-element{
        font-family: 'Source Code Pro', monospace;
        color: white;
        opacity: 0;
        transition: opacity 1s;
        display: block;
        margin: auto;
        text-align: center;
        font-size: calc(25px + 1vw);
        margin-top: 0.5em;
        background: rgba(10,10,50,.5);
        text-decoration: none;
    }
    #device-setup-procedure .network-element:hover{
        text-decoration: none!important;
        color:white!important;
    }
    #device-setup-procedure .network-element:first-child{
        margin-top:0;
    }
    #device-setup-procedure .container{
        margin: auto;
        margin-top: 10vh;
    }
    #device-setup-procedure .container h1{
        text-align: center;
        border: 0;
        margin: 0;
        font-size: calc(45px + 1.5vw);
        color: white;
        opacity: 0;
        transition: opacity 2s;
    }
    #device-setup-procedure .container input{
        font-family: 'Source Code Pro', monospace;
        border: 0;
        border-radius: 10px;
        box-shadow: 1px 0 20px 10px rgba(100,100,100,1);
        font-size: 2vw;
        padding: 0.5em;
        background: black;
        color: white;
        margin: auto;
        margin-top: 1.5em;
        display: block;
        outline: none;
        opacity: 0;
        transition: opacity 2s;
        width: 100%;
    }
    #device-setup-procedure .container button{
        margin: auto;
        display: block;
        margin-top: 5em;
        font-size: 3vw;
        border: 0;
        border-radius: 10px;
        background: black;
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
        opacity:0;
        transition: opacity 2s;
    }
    #device-setup-procedure .dShow{
        display: block!important;
    }
    #device-setup-procedure .dFlex{
        display: flex!important;
    }
    #device-setup-procedure .dNone{
        display:none!important;
    }
    #device-setup-procedure .op-transition-on{
        transition: opacity 1s;
    }
    #device-setup-procedure #modal-bg{
        display:none;
        position:absolute;
        top:0;
        left:0;
        width:100vw;
        height:100vh;
        z-index: 100;
        background: rgba(0,0,0,.8);
    }
    #device-setup-procedure #modal{
        position: absolute;
        left: 24vw;
        top: 7vw;
        display: none;
        margin: auto;
        width: 52vw;
        border: 2px solid rgba(255,255,255,.7);
        box-shadow: 1px 1px 50px 5px rgba(100,100,250,.45);
        border-radius: 10px;
        z-index: 101;
        color: white;
        font-size: calc(41px + 1vw);
        text-align: center;
        background: black;
        padding: 1em 0.5em 1em 0.5em;
    }

    #device-setup-procedure #modal input{
        font-family: 'Source Code Pro', monospace;
        border: 0;
        border-radius: 10px;
        box-shadow: 1px 0 10px 4px rgba(100,100,100,1);
        font-size: 2vw;
        width: 100%;
        padding: 0.5em;
        background: black;
        color: white;
        margin: auto;
        display: block;
        outline: none;
        margin-top: .5em;
    }
    #device-setup-procedure #modal button{
        margin: auto;
        margin-top: 2em;
        display: block;
        font-size: 2vw;
        border: 0;
        border-radius: 10px;
        background: black;
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
    }
    #device-setup-procedure #modal-title{
        margin: 0;
        font-family: 'Source Code Pro', monospace;
        font-size: 3vw;
    }
    #device-setup-procedure #modal h2{
        font-family: 'Ubuntu', sans-serif;
        font-size: 2vw;
        margin-top: 2.5em;
    }
    #device-setup-procedure #cancel-btn{
        position: fixed;
        bottom: 1em;
        left: 1em;
        background: rgba(200,30,30,1);
        font-weight: bold;
        color: black;
        border: 0;
        border-radius: 15px;
        font-size: calc(10px + 1vw);
        opacity: 1;
        transition: 1s opacity;
    }
    #device-setup-procedure .separator{
        width: 100%;
        height: 1px;
        background: white;
        margin-top: 0.5em;  
    }
    #device-setup-procedure .confirm-style{
        color: rgba(100,200,100,.9)!important;
    }

    /* Modal confirm loading effect */
    #device-setup-procedure #modal-confirm-loading{
        display:none;
        justify-content: center;
        align-items: center;
        background: #000;
        margin-top: 2em;
        opacity:0;
        transition: opacity .5s;
    }

    #device-setup-procedure #modal-confirm-loading div{
        width: 4vmax;
        height: 4vmax;
        border-right: 2px solid #ffffff;
        border-radius: 100%;
        animation: spinRight 800ms linear infinite;
        
        &:before, &:after {
            content: '';
            width: 3vmax;
            height: 3vmax;
            display: block;
            position: absolute;
            top: calc(50% - 1.5vmax);
            left: calc(50% - 1.5vmax);
            border-left: 1.5px solid #ffffff;
            border-radius: 100%;
            animation: spinLeft 800ms linear infinite;
        }
        
        &:after {
            width: 2vmax;
            height: 2vmax;
            top: calc(50% - 1vmax);
            left: calc(50% - 1vmax);
            border: 0;
            border-right: 1px solid #ffffff;
            animation: none;
        }
    }

    @keyframes spinLeft {
        from {transform:rotate(0deg);}
        to {transform:rotate(720deg);}
    }

    @keyframes spinRight {
        from {transform:rotate(360deg);}
        to {transform:rotate(0deg);}
    }

    /* Modal error*/
    #device-setup-procedure #modal-error{
        position: absolute;
        left: 26vw;
        top: 18vw;
        display: none;
        margin: auto;
        width: 48vw;
        border: 2px solid rgba(255,255,255,.7);
        box-shadow: 1px 1px 50px 5px rgba(250,100,100,.45);
        border-radius: 10px;
        z-index: 101;
        color: white;
        font-size: calc(40px + 1vw);
        text-align: center;
        background: black;
        padding: 1em 0.5em 1em 0.5em;
        opacity: 0;
        transition: opacity .3s;
    }
    #device-setup-procedure #modal-error h2{
        font-family: 'Ubuntu', sans-serif;
        margin: 0;
        font-size: 2.4vw;
        color: rgba(250,10,10,.7);
        text-shadow: 1px 1px 20px rgba(200,10,100,.5);
    }
    #device-setup-procedure #modal-error button{
        margin: auto;
        display: block;
        font-size: 2vw;
        border: 0;
        border-radius: 10px;
        background: rgba(255,255,255,.1);
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
        margin-top: 1em;
    }

    /* Device paired */
    #device-setup-procedure #device-paired{
        display: none;
        margin-top: 30vh!important;
    }
    #device-setup-procedure #device-paired-ok-btn {
        margin: auto;
        display: block;
        font-size: 2vw;
        border: 0;
        border-radius: 10px;
        background: rgba(255,255,255,.1);
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
        margin-top: 2.5em;
    }
}
/* Stili solo per dispositivi con larghezza massima di 600 pixel (tipicamente dispositivi mobili) */
@media only screen and (max-width: 600px) {
    #device-setup-procedure{
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */ /* Konqueror HTML */ /* Old versions of Firefox */ /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
        overflow: hidden;

        position: absolute;
        top:0;
        left:0;
        width:100%;
        height: 100vh;
        background: black;
    }
    #device-setup-procedure h1, #device-setup-procedure button{
        font-family: 'Ubuntu', sans-serif;
        outline:none!important;
    }
    #device-setup-procedure button:focus{
        outline:none!important;
    }
    #device-setup-procedure .op1{
        opacity: 1!important;
    }
    #device-setup-procedure .op0{
        opacity: 0!important;
    }
    #device-setup-procedure #network-list{
        margin-top: 30vw!important;
        opacity: 1;
        transition: opacity 1s;
    }
    #device-setup-procedure #network-list-to-select{
        margin-top: 4em;
    }
    #device-setup-procedure .network-element{
        font-family: 'Source Code Pro', monospace;
        color: white;
        opacity: 0;
        transition: opacity 1s;
        display: block;
        margin: auto;
        text-align: center;
        font-size: calc(16px + 1vw);
        margin-top: 1em;
        background: rgba(10,10,50,.5);
        text-decoration: none;
        display: flex;
        justify-items: center;
        align-items: center;
        justify-content: space-between;
    }
    #device-setup-procedure .network-element:hover{
        text-decoration: none!important;
        color:white!important;
    }
    #device-setup-procedure .network-element:first-child{
        margin-top:0;
    }
    #device-setup-procedure .container{
        margin: auto;
        margin-top: 20vh;
    }
    #device-setup-procedure .container h1{
        text-align: center;
        border: 0;
        margin: 0;
        font-size: calc(35px + 1vw);
        color: white;
        opacity: 0;
        transition: opacity 2s;
    }
    #device-setup-procedure .container input{
        font-family: 'Source Code Pro', monospace;
        border: 0;
        border-radius: 10px;
        box-shadow: 1px 0 20px 10px rgba(100,100,100,1);
        font-size: 7vw;
        padding: 0.5em;
        background: black;
        color: white;
        margin: auto;
        margin-top: 1.5em;
        display: block;
        outline: none;
        opacity: 0;
        transition: opacity 2s;
        width: 100%;
    }
    #device-setup-procedure .container button{
        margin: auto;
        display: block;
        margin-top: 2em;
        font-size: 7vw;
        border: 0;
        border-radius: 10px;
        background: black;
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
        opacity:0;
        transition: opacity 2s;
    }
    #device-setup-procedure .dShow{
        display: block!important;
    }
    #device-setup-procedure .dFlex{
        display: flex!important;
    }
    #device-setup-procedure .dNone{
        display:none!important;
    }
    #device-setup-procedure .op-transition-on{
        transition: opacity 1s;
    }
    #device-setup-procedure #modal-bg{
        display:none;
        position:absolute;
        top:0;
        left:0;
        width:100vw;
        height:100vh;
        z-index: 100;
        background: rgba(0,0,0,.8);
    }
    #device-setup-procedure #modal{
        position: absolute;
        left: 5vw;
        top: 55vw;
        display: none;
        margin: auto;
        width: 90%;
        border: 2px solid rgba(255,255,255,.7);
        box-shadow: 1px 1px 50px 5px rgba(100,100,250,.45);
        border-radius: 10px;
        z-index: 101;
        color: white;
        font-size: calc(41px + 1vw);
        text-align: center;
        background: black;
        padding: 0.5em 0.5em 0.5em 0.5em;
    }

    #device-setup-procedure #modal input{
        font-family: 'Source Code Pro', monospace;
        border: 0;
        border-radius: 10px;
        box-shadow: 1px 0 10px 4px rgba(100,100,100,1);
        font-size: 5vw;
        width: 100%;
        padding: 0.5em;
        background: black;
        color: white;
        margin: auto;
        display: block;
        outline: none;
        margin-top: .5em;
    }
    #device-setup-procedure #modal button{
        margin: auto;
        margin-top: 2em;
        display: block;
        font-size: 6vw;
        border: 0;
        border-radius: 10px;
        background: black;
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
    }
    #device-setup-procedure #modal-title{
        margin: 0;
        font-family: 'Source Code Pro', monospace;
        font-size: 7vw;
    }
    #device-setup-procedure #modal h2{
        font-family: 'Ubuntu', sans-serif;
        font-size: 5vw;
        margin-top: 2.5em;
    }
    #device-setup-procedure #cancel-btn{
        position: fixed;
        bottom: 1em;
        left: 1em;
        background: rgba(200,30,30,1);
        font-weight: bold;
        color: black;
        border: 2px solid rgba(100,0,0,.5);
        border-radius: 15px;
        font-size: calc(10px + 1vw);
        opacity: 1;
        transition: 1s opacity;
        padding: .5em;
    }
    #device-setup-procedure .separator{
        width: 100%;
        height: 1px;
        background: white;
        margin-top: 0.2em;  
    }
    #device-setup-procedure .confirm-style{
        color: rgba(100,200,100,.9)!important;
    }

    /* Modal confirm loading effect */
    #device-setup-procedure #modal-confirm-loading{
        display:none;
        justify-content: center;
        align-items: center;
        background: #000;
        margin-top: .7em;
        opacity:0;
        transition: opacity .5s;
    }

    #device-setup-procedure #modal-confirm-loading div{
        width: 4vmax;
        height: 4vmax;
        border-right: 2px solid #ffffff;
        border-radius: 100%;
        animation: spinRight 800ms linear infinite;
        
        &:before, &:after {
            content: '';
            width: 3vmax;
            height: 3vmax;
            display: block;
            position: absolute;
            top: calc(50% - 1.5vmax);
            left: calc(50% - 1.5vmax);
            border-left: 1.5px solid #ffffff;
            border-radius: 100%;
            animation: spinLeft 800ms linear infinite;
        }
        
        &:after {
            width: 2vmax;
            height: 2vmax;
            top: calc(50% - 1vmax);
            left: calc(50% - 1vmax);
            border: 0;
            border-right: 1px solid #ffffff;
            animation: none;
        }
    }

    @keyframes spinLeft {
        from {transform:rotate(0deg);}
        to {transform:rotate(720deg);}
    }

    @keyframes spinRight {
        from {transform:rotate(360deg);}
        to {transform:rotate(0deg);}
    }

    /* Modal error*/
    #device-setup-procedure #modal-error{
        position: absolute;
        left: 10vw;
        top: 70vw;
        display: none;
        margin: auto;
        width: 80vw;
        border: 2px solid rgba(255,255,255,.7);
        box-shadow: 1px 1px 50px 5px rgba(250,100,100,.45);
        border-radius: 10px;
        z-index: 101;
        color: white;
        font-size: calc(40px + 1vw);
        text-align: center;
        background: black;
        padding: 0.7em 0.5em 0.5em 0.5em;
        opacity: 0;
        transition: opacity .3s;
    }
    #device-setup-procedure #modal-error h2{
        font-family: 'Ubuntu', sans-serif;
        margin: 0;
        font-size: 6vw;
        color: rgba(250,10,10,.7);
        text-shadow: 1px 1px 20px rgba(200,10,100,.5);
    }
    #device-setup-procedure #modal-error button{
        margin: auto;
        display: block;
        font-size: 5vw;
        border: 0;
        border-radius: 10px;
        background: rgba(255,255,255,.1);
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
        margin-top: 1.25em;
    }

    /* Device paired */
    #device-setup-procedure #device-paired{
        display: none;
        margin-top: 37vh!important;
    }
    #device-setup-procedure #device-paired-ok-btn {
        margin: auto;
        display: block;
        font-size: 6vw;
        border: 0;
        border-radius: 10px;
        background: rgba(255,255,255,.1);
        padding: 0.25em 0.5em;
        cursor: pointer;
        color: white;
        margin-top: 1.5em;
    }
}`, "",{"version":3,"sources":["webpack://./css/nuovo_dispositivo.css"],"names":[],"mappings":"AAAA;IACI;QACI,2BAA2B,EAAE,eAAe;QAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;QAClD,iBAAiB,EAAE;kFACuD;QAC1E,gBAAgB;;QAEhB,kBAAkB;QAClB,KAAK;QACL,MAAM;QACN,UAAU;QACV,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,iCAAiC;QACjC,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,yBAAyB;QACzB,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,yCAAyC;QACzC,YAAY;QACZ,UAAU;QACV,sBAAsB;QACtB,cAAc;QACd,YAAY;QACZ,kBAAkB;QAClB,2BAA2B;QAC3B,iBAAiB;QACjB,6BAA6B;QAC7B,qBAAqB;IACzB;IACA;QACI,+BAA+B;QAC/B,qBAAqB;IACzB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,6BAA6B;QAC7B,YAAY;QACZ,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,yCAAyC;QACzC,SAAS;QACT,mBAAmB;QACnB,+CAA+C;QAC/C,cAAc;QACd,cAAc;QACd,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,aAAa;QACb,UAAU;QACV,sBAAsB;QACtB,WAAW;IACf;IACA;QACI,YAAY;QACZ,cAAc;QACd,eAAe;QACf,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,KAAK;QACL,MAAM;QACN,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,aAAa;QACb,YAAY;QACZ,WAAW;QACX,sCAAsC;QACtC,kDAAkD;QAClD,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,2BAA2B;QAC3B,kBAAkB;QAClB,iBAAiB;QACjB,4BAA4B;IAChC;;IAEA;QACI,yCAAyC;QACzC,SAAS;QACT,mBAAmB;QACnB,8CAA8C;QAC9C,cAAc;QACd,WAAW;QACX,cAAc;QACd,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;QACf,cAAc;QACd,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,eAAe;QACf,YAAY;IAChB;IACA;QACI,SAAS;QACT,yCAAyC;QACzC,cAAc;IAClB;IACA;QACI,iCAAiC;QACjC,cAAc;QACd,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,WAAW;QACX,SAAS;QACT,6BAA6B;QAC7B,iBAAiB;QACjB,YAAY;QACZ,SAAS;QACT,mBAAmB;QACnB,2BAA2B;QAC3B,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,WAAW;QACX,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,qCAAqC;IACzC;;IAEA,iCAAiC;IACjC;QACI,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;QAChB,eAAe;QACf,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,+BAA+B;QAC/B,mBAAmB;QACnB,0CAA0C;;QAE1C;YACI,WAAW;YACX,YAAY;YACZ,aAAa;YACb,cAAc;YACd,kBAAkB;YAClB,wBAAwB;YACxB,yBAAyB;YACzB,gCAAgC;YAChC,mBAAmB;YACnB,yCAAyC;QAC7C;;QAEA;YACI,YAAY;YACZ,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,SAAS;YACT,+BAA+B;YAC/B,eAAe;QACnB;IACJ;;IAEA;QACI,MAAM,sBAAsB,CAAC;QAC7B,IAAI,wBAAwB,CAAC;IACjC;;IAEA;QACI,MAAM,wBAAwB,CAAC;QAC/B,IAAI,sBAAsB,CAAC;IAC/B;;IAEA,eAAe;IACf;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,aAAa;QACb,YAAY;QACZ,WAAW;QACX,sCAAsC;QACtC,kDAAkD;QAClD,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,2BAA2B;QAC3B,kBAAkB;QAClB,iBAAiB;QACjB,4BAA4B;QAC5B,UAAU;QACV,uBAAuB;IAC3B;IACA;QACI,iCAAiC;QACjC,SAAS;QACT,gBAAgB;QAChB,yBAAyB;QACzB,6CAA6C;IACjD;IACA;QACI,YAAY;QACZ,cAAc;QACd,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,gCAAgC;QAChC,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,eAAe;IACnB;;IAEA,kBAAkB;IAClB;QACI,aAAa;QACb,0BAA0B;IAC9B;IACA;QACI,YAAY;QACZ,cAAc;QACd,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,gCAAgC;QAChC,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,iBAAiB;IACrB;AACJ;AACA,mGAAmG;AACnG;IACI;QACI,2BAA2B,EAAE,eAAe;QAC5C,yBAAyB,EAAE,WAAW,EACZ,mBAAmB,EACrB,4BAA4B,EAC7B,2BAA2B;QAClD,iBAAiB,EAAE;kFACuD;QAC1E,gBAAgB;;QAEhB,kBAAkB;QAClB,KAAK;QACL,MAAM;QACN,UAAU;QACV,aAAa;QACb,iBAAiB;IACrB;IACA;QACI,iCAAiC;QACjC,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,oBAAoB;IACxB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,0BAA0B;QAC1B,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,yCAAyC;QACzC,YAAY;QACZ,UAAU;QACV,sBAAsB;QACtB,cAAc;QACd,YAAY;QACZ,kBAAkB;QAClB,2BAA2B;QAC3B,eAAe;QACf,6BAA6B;QAC7B,qBAAqB;QACrB,aAAa;QACb,qBAAqB;QACrB,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,+BAA+B;QAC/B,qBAAqB;IACzB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,YAAY;QACZ,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,yCAAyC;QACzC,SAAS;QACT,mBAAmB;QACnB,+CAA+C;QAC/C,cAAc;QACd,cAAc;QACd,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,cAAc;QACd,aAAa;QACb,UAAU;QACV,sBAAsB;QACtB,WAAW;IACf;IACA;QACI,YAAY;QACZ,cAAc;QACd,eAAe;QACf,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,YAAY;QACZ,iBAAiB;QACjB,KAAK;QACL,MAAM;QACN,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,0BAA0B;IAC9B;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,aAAa;QACb,YAAY;QACZ,UAAU;QACV,sCAAsC;QACtC,kDAAkD;QAClD,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,2BAA2B;QAC3B,kBAAkB;QAClB,iBAAiB;QACjB,gCAAgC;IACpC;;IAEA;QACI,yCAAyC;QACzC,SAAS;QACT,mBAAmB;QACnB,8CAA8C;QAC9C,cAAc;QACd,WAAW;QACX,cAAc;QACd,iBAAiB;QACjB,YAAY;QACZ,YAAY;QACZ,cAAc;QACd,aAAa;QACb,gBAAgB;IACpB;IACA;QACI,YAAY;QACZ,eAAe;QACf,cAAc;QACd,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,iBAAiB;QACjB,qBAAqB;QACrB,eAAe;QACf,YAAY;IAChB;IACA;QACI,SAAS;QACT,yCAAyC;QACzC,cAAc;IAClB;IACA;QACI,iCAAiC;QACjC,cAAc;QACd,iBAAiB;IACrB;IACA;QACI,eAAe;QACf,WAAW;QACX,SAAS;QACT,6BAA6B;QAC7B,iBAAiB;QACjB,YAAY;QACZ,kCAAkC;QAClC,mBAAmB;QACnB,2BAA2B;QAC3B,UAAU;QACV,sBAAsB;QACtB,aAAa;IACjB;IACA;QACI,WAAW;QACX,WAAW;QACX,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,qCAAqC;IACzC;;IAEA,iCAAiC;IACjC;QACI,YAAY;QACZ,uBAAuB;QACvB,mBAAmB;QACnB,gBAAgB;QAChB,gBAAgB;QAChB,SAAS;QACT,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,+BAA+B;QAC/B,mBAAmB;QACnB,0CAA0C;;QAE1C;YACI,WAAW;YACX,YAAY;YACZ,aAAa;YACb,cAAc;YACd,kBAAkB;YAClB,wBAAwB;YACxB,yBAAyB;YACzB,gCAAgC;YAChC,mBAAmB;YACnB,yCAAyC;QAC7C;;QAEA;YACI,YAAY;YACZ,aAAa;YACb,sBAAsB;YACtB,uBAAuB;YACvB,SAAS;YACT,+BAA+B;YAC/B,eAAe;QACnB;IACJ;;IAEA;QACI,MAAM,sBAAsB,CAAC;QAC7B,IAAI,wBAAwB,CAAC;IACjC;;IAEA;QACI,MAAM,wBAAwB,CAAC;QAC/B,IAAI,sBAAsB,CAAC;IAC/B;;IAEA,eAAe;IACf;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,aAAa;QACb,YAAY;QACZ,WAAW;QACX,sCAAsC;QACtC,kDAAkD;QAClD,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,2BAA2B;QAC3B,kBAAkB;QAClB,iBAAiB;QACjB,gCAAgC;QAChC,UAAU;QACV,uBAAuB;IAC3B;IACA;QACI,iCAAiC;QACjC,SAAS;QACT,cAAc;QACd,yBAAyB;QACzB,6CAA6C;IACjD;IACA;QACI,YAAY;QACZ,cAAc;QACd,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,gCAAgC;QAChC,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,kBAAkB;IACtB;;IAEA,kBAAkB;IAClB;QACI,aAAa;QACb,0BAA0B;IAC9B;IACA;QACI,YAAY;QACZ,cAAc;QACd,cAAc;QACd,SAAS;QACT,mBAAmB;QACnB,gCAAgC;QAChC,qBAAqB;QACrB,eAAe;QACf,YAAY;QACZ,iBAAiB;IACrB;AACJ","sourcesContent":["@media only screen and (min-width: 600px) {\n    #device-setup-procedure{\n        -webkit-touch-callout: none; /* iOS Safari */\n        -webkit-user-select: none; /* Safari */\n        -khtml-user-select: none; /* Konqueror HTML */\n        -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n        user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome, Edge, Opera and Firefox */\n        overflow: hidden;\n\n        position: absolute;\n        top:0;\n        left:0;\n        width:100%;\n        height: 100vh;\n        background: black;\n    }\n    #device-setup-procedure h1, #device-setup-procedure button{\n        font-family: 'Ubuntu', sans-serif;\n        outline:none!important;\n    }\n    #device-setup-procedure button:focus{\n        outline:none!important;\n    }\n    #device-setup-procedure .op1{\n        opacity: 1!important;\n    }\n    #device-setup-procedure .op0{\n        opacity: 0!important;\n    }\n    #device-setup-procedure #network-list{\n        margin-top: 2vw!important;\n        opacity: 1;\n        transition: opacity 1s;\n    }\n    #device-setup-procedure #network-list-to-select{\n        margin-top: 3em;\n        padding: 5em;\n    }\n    #device-setup-procedure .network-element{\n        font-family: 'Source Code Pro', monospace;\n        color: white;\n        opacity: 0;\n        transition: opacity 1s;\n        display: block;\n        margin: auto;\n        text-align: center;\n        font-size: calc(25px + 1vw);\n        margin-top: 0.5em;\n        background: rgba(10,10,50,.5);\n        text-decoration: none;\n    }\n    #device-setup-procedure .network-element:hover{\n        text-decoration: none!important;\n        color:white!important;\n    }\n    #device-setup-procedure .network-element:first-child{\n        margin-top:0;\n    }\n    #device-setup-procedure .container{\n        margin: auto;\n        margin-top: 10vh;\n    }\n    #device-setup-procedure .container h1{\n        text-align: center;\n        border: 0;\n        margin: 0;\n        font-size: calc(45px + 1.5vw);\n        color: white;\n        opacity: 0;\n        transition: opacity 2s;\n    }\n    #device-setup-procedure .container input{\n        font-family: 'Source Code Pro', monospace;\n        border: 0;\n        border-radius: 10px;\n        box-shadow: 1px 0 20px 10px rgba(100,100,100,1);\n        font-size: 2vw;\n        padding: 0.5em;\n        background: black;\n        color: white;\n        margin: auto;\n        margin-top: 1.5em;\n        display: block;\n        outline: none;\n        opacity: 0;\n        transition: opacity 2s;\n        width: 100%;\n    }\n    #device-setup-procedure .container button{\n        margin: auto;\n        display: block;\n        margin-top: 5em;\n        font-size: 3vw;\n        border: 0;\n        border-radius: 10px;\n        background: black;\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n        opacity:0;\n        transition: opacity 2s;\n    }\n    #device-setup-procedure .dShow{\n        display: block!important;\n    }\n    #device-setup-procedure .dFlex{\n        display: flex!important;\n    }\n    #device-setup-procedure .dNone{\n        display:none!important;\n    }\n    #device-setup-procedure .op-transition-on{\n        transition: opacity 1s;\n    }\n    #device-setup-procedure #modal-bg{\n        display:none;\n        position:absolute;\n        top:0;\n        left:0;\n        width:100vw;\n        height:100vh;\n        z-index: 100;\n        background: rgba(0,0,0,.8);\n    }\n    #device-setup-procedure #modal{\n        position: absolute;\n        left: 24vw;\n        top: 7vw;\n        display: none;\n        margin: auto;\n        width: 52vw;\n        border: 2px solid rgba(255,255,255,.7);\n        box-shadow: 1px 1px 50px 5px rgba(100,100,250,.45);\n        border-radius: 10px;\n        z-index: 101;\n        color: white;\n        font-size: calc(41px + 1vw);\n        text-align: center;\n        background: black;\n        padding: 1em 0.5em 1em 0.5em;\n    }\n\n    #device-setup-procedure #modal input{\n        font-family: 'Source Code Pro', monospace;\n        border: 0;\n        border-radius: 10px;\n        box-shadow: 1px 0 10px 4px rgba(100,100,100,1);\n        font-size: 2vw;\n        width: 100%;\n        padding: 0.5em;\n        background: black;\n        color: white;\n        margin: auto;\n        display: block;\n        outline: none;\n        margin-top: .5em;\n    }\n    #device-setup-procedure #modal button{\n        margin: auto;\n        margin-top: 2em;\n        display: block;\n        font-size: 2vw;\n        border: 0;\n        border-radius: 10px;\n        background: black;\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n    }\n    #device-setup-procedure #modal-title{\n        margin: 0;\n        font-family: 'Source Code Pro', monospace;\n        font-size: 3vw;\n    }\n    #device-setup-procedure #modal h2{\n        font-family: 'Ubuntu', sans-serif;\n        font-size: 2vw;\n        margin-top: 2.5em;\n    }\n    #device-setup-procedure #cancel-btn{\n        position: fixed;\n        bottom: 1em;\n        left: 1em;\n        background: rgba(200,30,30,1);\n        font-weight: bold;\n        color: black;\n        border: 0;\n        border-radius: 15px;\n        font-size: calc(10px + 1vw);\n        opacity: 1;\n        transition: 1s opacity;\n    }\n    #device-setup-procedure .separator{\n        width: 100%;\n        height: 1px;\n        background: white;\n        margin-top: 0.5em;  \n    }\n    #device-setup-procedure .confirm-style{\n        color: rgba(100,200,100,.9)!important;\n    }\n\n    /* Modal confirm loading effect */\n    #device-setup-procedure #modal-confirm-loading{\n        display:none;\n        justify-content: center;\n        align-items: center;\n        background: #000;\n        margin-top: 2em;\n        opacity:0;\n        transition: opacity .5s;\n    }\n\n    #device-setup-procedure #modal-confirm-loading div{\n        width: 4vmax;\n        height: 4vmax;\n        border-right: 2px solid #ffffff;\n        border-radius: 100%;\n        animation: spinRight 800ms linear infinite;\n        \n        &:before, &:after {\n            content: '';\n            width: 3vmax;\n            height: 3vmax;\n            display: block;\n            position: absolute;\n            top: calc(50% - 1.5vmax);\n            left: calc(50% - 1.5vmax);\n            border-left: 1.5px solid #ffffff;\n            border-radius: 100%;\n            animation: spinLeft 800ms linear infinite;\n        }\n        \n        &:after {\n            width: 2vmax;\n            height: 2vmax;\n            top: calc(50% - 1vmax);\n            left: calc(50% - 1vmax);\n            border: 0;\n            border-right: 1px solid #ffffff;\n            animation: none;\n        }\n    }\n\n    @keyframes spinLeft {\n        from {transform:rotate(0deg);}\n        to {transform:rotate(720deg);}\n    }\n\n    @keyframes spinRight {\n        from {transform:rotate(360deg);}\n        to {transform:rotate(0deg);}\n    }\n\n    /* Modal error*/\n    #device-setup-procedure #modal-error{\n        position: absolute;\n        left: 26vw;\n        top: 18vw;\n        display: none;\n        margin: auto;\n        width: 48vw;\n        border: 2px solid rgba(255,255,255,.7);\n        box-shadow: 1px 1px 50px 5px rgba(250,100,100,.45);\n        border-radius: 10px;\n        z-index: 101;\n        color: white;\n        font-size: calc(40px + 1vw);\n        text-align: center;\n        background: black;\n        padding: 1em 0.5em 1em 0.5em;\n        opacity: 0;\n        transition: opacity .3s;\n    }\n    #device-setup-procedure #modal-error h2{\n        font-family: 'Ubuntu', sans-serif;\n        margin: 0;\n        font-size: 2.4vw;\n        color: rgba(250,10,10,.7);\n        text-shadow: 1px 1px 20px rgba(200,10,100,.5);\n    }\n    #device-setup-procedure #modal-error button{\n        margin: auto;\n        display: block;\n        font-size: 2vw;\n        border: 0;\n        border-radius: 10px;\n        background: rgba(255,255,255,.1);\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n        margin-top: 1em;\n    }\n\n    /* Device paired */\n    #device-setup-procedure #device-paired{\n        display: none;\n        margin-top: 30vh!important;\n    }\n    #device-setup-procedure #device-paired-ok-btn {\n        margin: auto;\n        display: block;\n        font-size: 2vw;\n        border: 0;\n        border-radius: 10px;\n        background: rgba(255,255,255,.1);\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n        margin-top: 2.5em;\n    }\n}\n/* Stili solo per dispositivi con larghezza massima di 600 pixel (tipicamente dispositivi mobili) */\n@media only screen and (max-width: 600px) {\n    #device-setup-procedure{\n        -webkit-touch-callout: none; /* iOS Safari */\n        -webkit-user-select: none; /* Safari */\n        -khtml-user-select: none; /* Konqueror HTML */\n        -moz-user-select: none; /* Old versions of Firefox */\n        -ms-user-select: none; /* Internet Explorer/Edge */\n        user-select: none; /* Non-prefixed version, currently\n                                    supported by Chrome, Edge, Opera and Firefox */\n        overflow: hidden;\n\n        position: absolute;\n        top:0;\n        left:0;\n        width:100%;\n        height: 100vh;\n        background: black;\n    }\n    #device-setup-procedure h1, #device-setup-procedure button{\n        font-family: 'Ubuntu', sans-serif;\n        outline:none!important;\n    }\n    #device-setup-procedure button:focus{\n        outline:none!important;\n    }\n    #device-setup-procedure .op1{\n        opacity: 1!important;\n    }\n    #device-setup-procedure .op0{\n        opacity: 0!important;\n    }\n    #device-setup-procedure #network-list{\n        margin-top: 30vw!important;\n        opacity: 1;\n        transition: opacity 1s;\n    }\n    #device-setup-procedure #network-list-to-select{\n        margin-top: 4em;\n    }\n    #device-setup-procedure .network-element{\n        font-family: 'Source Code Pro', monospace;\n        color: white;\n        opacity: 0;\n        transition: opacity 1s;\n        display: block;\n        margin: auto;\n        text-align: center;\n        font-size: calc(16px + 1vw);\n        margin-top: 1em;\n        background: rgba(10,10,50,.5);\n        text-decoration: none;\n        display: flex;\n        justify-items: center;\n        align-items: center;\n        justify-content: space-between;\n    }\n    #device-setup-procedure .network-element:hover{\n        text-decoration: none!important;\n        color:white!important;\n    }\n    #device-setup-procedure .network-element:first-child{\n        margin-top:0;\n    }\n    #device-setup-procedure .container{\n        margin: auto;\n        margin-top: 20vh;\n    }\n    #device-setup-procedure .container h1{\n        text-align: center;\n        border: 0;\n        margin: 0;\n        font-size: calc(35px + 1vw);\n        color: white;\n        opacity: 0;\n        transition: opacity 2s;\n    }\n    #device-setup-procedure .container input{\n        font-family: 'Source Code Pro', monospace;\n        border: 0;\n        border-radius: 10px;\n        box-shadow: 1px 0 20px 10px rgba(100,100,100,1);\n        font-size: 7vw;\n        padding: 0.5em;\n        background: black;\n        color: white;\n        margin: auto;\n        margin-top: 1.5em;\n        display: block;\n        outline: none;\n        opacity: 0;\n        transition: opacity 2s;\n        width: 100%;\n    }\n    #device-setup-procedure .container button{\n        margin: auto;\n        display: block;\n        margin-top: 2em;\n        font-size: 7vw;\n        border: 0;\n        border-radius: 10px;\n        background: black;\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n        opacity:0;\n        transition: opacity 2s;\n    }\n    #device-setup-procedure .dShow{\n        display: block!important;\n    }\n    #device-setup-procedure .dFlex{\n        display: flex!important;\n    }\n    #device-setup-procedure .dNone{\n        display:none!important;\n    }\n    #device-setup-procedure .op-transition-on{\n        transition: opacity 1s;\n    }\n    #device-setup-procedure #modal-bg{\n        display:none;\n        position:absolute;\n        top:0;\n        left:0;\n        width:100vw;\n        height:100vh;\n        z-index: 100;\n        background: rgba(0,0,0,.8);\n    }\n    #device-setup-procedure #modal{\n        position: absolute;\n        left: 5vw;\n        top: 55vw;\n        display: none;\n        margin: auto;\n        width: 90%;\n        border: 2px solid rgba(255,255,255,.7);\n        box-shadow: 1px 1px 50px 5px rgba(100,100,250,.45);\n        border-radius: 10px;\n        z-index: 101;\n        color: white;\n        font-size: calc(41px + 1vw);\n        text-align: center;\n        background: black;\n        padding: 0.5em 0.5em 0.5em 0.5em;\n    }\n\n    #device-setup-procedure #modal input{\n        font-family: 'Source Code Pro', monospace;\n        border: 0;\n        border-radius: 10px;\n        box-shadow: 1px 0 10px 4px rgba(100,100,100,1);\n        font-size: 5vw;\n        width: 100%;\n        padding: 0.5em;\n        background: black;\n        color: white;\n        margin: auto;\n        display: block;\n        outline: none;\n        margin-top: .5em;\n    }\n    #device-setup-procedure #modal button{\n        margin: auto;\n        margin-top: 2em;\n        display: block;\n        font-size: 6vw;\n        border: 0;\n        border-radius: 10px;\n        background: black;\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n    }\n    #device-setup-procedure #modal-title{\n        margin: 0;\n        font-family: 'Source Code Pro', monospace;\n        font-size: 7vw;\n    }\n    #device-setup-procedure #modal h2{\n        font-family: 'Ubuntu', sans-serif;\n        font-size: 5vw;\n        margin-top: 2.5em;\n    }\n    #device-setup-procedure #cancel-btn{\n        position: fixed;\n        bottom: 1em;\n        left: 1em;\n        background: rgba(200,30,30,1);\n        font-weight: bold;\n        color: black;\n        border: 2px solid rgba(100,0,0,.5);\n        border-radius: 15px;\n        font-size: calc(10px + 1vw);\n        opacity: 1;\n        transition: 1s opacity;\n        padding: .5em;\n    }\n    #device-setup-procedure .separator{\n        width: 100%;\n        height: 1px;\n        background: white;\n        margin-top: 0.2em;  \n    }\n    #device-setup-procedure .confirm-style{\n        color: rgba(100,200,100,.9)!important;\n    }\n\n    /* Modal confirm loading effect */\n    #device-setup-procedure #modal-confirm-loading{\n        display:none;\n        justify-content: center;\n        align-items: center;\n        background: #000;\n        margin-top: .7em;\n        opacity:0;\n        transition: opacity .5s;\n    }\n\n    #device-setup-procedure #modal-confirm-loading div{\n        width: 4vmax;\n        height: 4vmax;\n        border-right: 2px solid #ffffff;\n        border-radius: 100%;\n        animation: spinRight 800ms linear infinite;\n        \n        &:before, &:after {\n            content: '';\n            width: 3vmax;\n            height: 3vmax;\n            display: block;\n            position: absolute;\n            top: calc(50% - 1.5vmax);\n            left: calc(50% - 1.5vmax);\n            border-left: 1.5px solid #ffffff;\n            border-radius: 100%;\n            animation: spinLeft 800ms linear infinite;\n        }\n        \n        &:after {\n            width: 2vmax;\n            height: 2vmax;\n            top: calc(50% - 1vmax);\n            left: calc(50% - 1vmax);\n            border: 0;\n            border-right: 1px solid #ffffff;\n            animation: none;\n        }\n    }\n\n    @keyframes spinLeft {\n        from {transform:rotate(0deg);}\n        to {transform:rotate(720deg);}\n    }\n\n    @keyframes spinRight {\n        from {transform:rotate(360deg);}\n        to {transform:rotate(0deg);}\n    }\n\n    /* Modal error*/\n    #device-setup-procedure #modal-error{\n        position: absolute;\n        left: 10vw;\n        top: 70vw;\n        display: none;\n        margin: auto;\n        width: 80vw;\n        border: 2px solid rgba(255,255,255,.7);\n        box-shadow: 1px 1px 50px 5px rgba(250,100,100,.45);\n        border-radius: 10px;\n        z-index: 101;\n        color: white;\n        font-size: calc(40px + 1vw);\n        text-align: center;\n        background: black;\n        padding: 0.7em 0.5em 0.5em 0.5em;\n        opacity: 0;\n        transition: opacity .3s;\n    }\n    #device-setup-procedure #modal-error h2{\n        font-family: 'Ubuntu', sans-serif;\n        margin: 0;\n        font-size: 6vw;\n        color: rgba(250,10,10,.7);\n        text-shadow: 1px 1px 20px rgba(200,10,100,.5);\n    }\n    #device-setup-procedure #modal-error button{\n        margin: auto;\n        display: block;\n        font-size: 5vw;\n        border: 0;\n        border-radius: 10px;\n        background: rgba(255,255,255,.1);\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n        margin-top: 1.25em;\n    }\n\n    /* Device paired */\n    #device-setup-procedure #device-paired{\n        display: none;\n        margin-top: 37vh!important;\n    }\n    #device-setup-procedure #device-paired-ok-btn {\n        margin: auto;\n        display: block;\n        font-size: 6vw;\n        border: 0;\n        border-radius: 10px;\n        background: rgba(255,255,255,.1);\n        padding: 0.25em 0.5em;\n        cursor: pointer;\n        color: white;\n        margin-top: 1.5em;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
